export { default as ElAutocomplete } from 'element-plus/lib/el-autocomplete';
import ElAvatar from 'element-plus/lib/el-avatar';
import ElBadge from 'element-plus/lib/el-badge';
export { default as ElBadge } from 'element-plus/lib/el-badge';

import ElButton from './el-button';
export { default as ElButton } from './el-button';

import ElButtonGroup from 'element-plus/lib/el-button-group';
export { default as ElButtonGroup } from 'element-plus/lib/el-button-group';

import ElCarousel from 'element-plus/lib/el-carousel';
export { default as ElCarousel } from 'element-plus/lib/el-carousel';

import ElCarouselItem from 'element-plus/lib/el-carousel-item';
export { default as ElCarouselItem } from 'element-plus/lib/el-carousel-item';
import ElCheckbox from 'element-plus/lib/el-checkbox';
export { default as ElCheckbox } from 'element-plus/lib/el-checkbox';
import ElCheckboxButton from 'element-plus/lib/el-checkbox-button';
export { default as ElCheckboxButton } from 'element-plus/lib/el-checkbox-button';
import ElCheckboxGroup from 'element-plus/lib/el-checkbox-group';
export { default as ElCheckboxGroup } from 'element-plus/lib/el-checkbox-group';
import ElCol from 'element-plus/lib/el-col';
export { default as ElCol } from 'element-plus/lib/el-col';
import ElCollapse from 'element-plus/lib/el-collapse';
export { default as ElCollapse } from 'element-plus/lib/el-collapse';
import ElCollapseItem from 'element-plus/lib/el-collapse-item';
export { default as ElCollapseItem } from 'element-plus/lib/el-collapse-item';
import ElCollapseTransition from 'element-plus/lib/el-collapse-transition';
export { default as ElCollapseTransition } from 'element-plus/lib/el-collapse-transition';
import ElDatePicker from 'element-plus/lib/el-date-picker';
export { default as ElDatePicker } from 'element-plus/lib/el-date-picker';
import ElDialog from 'element-plus/lib/el-dialog';
export { default as ElDialog } from 'element-plus/lib/el-dialog';
import ElDrawer from 'element-plus/lib/el-drawer';
export { default as ElDrawer } from 'element-plus/lib/el-drawer';
import ElDropdown from 'element-plus/lib/el-dropdown';
export { default as ElDropdown } from 'element-plus/lib/el-dropdown';
import ElDropdownItem from 'element-plus/lib/el-dropdown-item';
export { default as ElDropdownItem } from 'element-plus/lib/el-dropdown-item';
import ElDropdownMenu from 'element-plus/lib/el-dropdown-menu';
export { default as ElDropdownMenu } from 'element-plus/lib/el-dropdown-menu';
import ElEmpty from 'element-plus/lib/el-empty';
export { default as ElEmpty } from 'element-plus/lib/el-empty';
import ElForm from './el-form';
export { default as ElForm } from './el-form';

import ElProgress from './el-progress'
export {default as ElProgress } from './el-progress'
import ElFormItem from './el-form-item';
export { default as ElFormItem } from './el-form-item';
export { default as ElIcon } from 'element-plus/lib/el-icon';
import ElImage from 'element-plus/lib/el-image';
import ElInfiniteScroll from 'element-plus/lib/el-infinite-scroll';
export { default as ElInfiniteScroll } from 'element-plus/lib/el-infinite-scroll';
import ElInput from 'element-plus/lib/el-input';
export { default as ElInput } from 'element-plus/lib/el-input';
import ElInputNumber from 'element-plus/lib/el-input-number';
export { default as ElInputNumber } from 'element-plus/lib/el-input-number';
import ElLoading from 'element-plus/lib/el-loading';
export { default as ElLoading } from 'element-plus/lib/el-loading';
import ElMessage from './el-message';
export { default as ElMessage } from './el-message';
import ElMessageBox from 'element-plus/lib/el-message-box';
export { default as ElMessageBox } from 'element-plus/lib/el-message-box';
import ElNotification from 'element-plus/lib/el-notification';
export { default as ElNotification } from 'element-plus/lib/el-notification';
import ElOption from 'element-plus/lib/el-option';
export { default as ElOption } from 'element-plus/lib/el-option';
import ElRadio from 'element-plus/lib/el-radio';
export { default as ElRadio } from 'element-plus/lib/el-radio';
import ElRadioButton from 'element-plus/lib/el-radio-button';
export { default as ElRadioButton } from 'element-plus/lib/el-radio-button';
import ElRadioGroup from 'element-plus/lib/el-radio-group';
export { default as ElRadioGroup } from 'element-plus/lib/el-radio-group';
import ElRate from 'element-plus/lib/el-rate';
export { default as ElRate } from 'element-plus/lib/el-rate';
import ElSelect from 'element-plus/lib/el-select';
export { default as ElSelect } from 'element-plus/lib/el-select';
import ElSwitch from 'element-plus/lib/el-switch';
export { default as ElSwitch } from 'element-plus/lib/el-switch';
import ElTabPane from 'element-plus/lib/el-tab-pane';
export { default as ElTabPane } from 'element-plus/lib/el-tab-pane';
import ElTable from 'element-plus/lib/el-table';
export { default as ElTable } from 'element-plus/lib/el-table';
import ElTableColumn from 'element-plus/lib/el-table-column';
export { default as ElTableColumn } from 'element-plus/lib/el-table-column';
import ElTabs from 'element-plus/lib/el-tabs';
export { default as ElTabs } from 'element-plus/lib/el-tabs';
import ElTag from 'element-plus/lib/el-tag';
export { default as ElTag } from 'element-plus/lib/el-tag';
import ElTooltip from 'element-plus/lib/el-tooltip';
export { default as ElTooltip } from 'element-plus/lib/el-tooltip';
import ElUpload from './el-upload';
export { default as ElUpload } from './el-upload';
import { use } from 'element-plus/lib/locale';
import { setConfig } from 'element-plus/lib/utils/config';
import ElSkeleton from 'element-plus/lib/el-skeleton';
export { default as ElSkeleton } from 'element-plus/lib/el-skeleton';
import ElSkeletonItem from 'element-plus/lib/el-skeleton-item';
export { default as ElSkeletonItem } from 'element-plus/lib/el-skeleton-item';

const version = '1.0.1-beta.24';

const version$1 = version;
const locale = use;
const defaultInstallOpt = {
    size: '',
    zIndex: 2000,
};
const components = [
    ElAvatar,
    ElBadge,

    ElButton,
    ElButtonGroup,

    ElCarousel,
    ElCarouselItem,

    ElCheckbox,
    ElCheckboxButton,
    ElCheckboxGroup,
    ElCol,
    ElCollapse,
    ElCollapseItem,
    ElCollapseTransition,

    ElProgress,
    ElDatePicker,
    ElDialog,
    ElDrawer,
    ElDropdown,
    ElDropdownItem,
    ElDropdownMenu,
    ElEmpty,
    ElForm,
    ElFormItem,
    ElImage,
    ElInput,
    ElInputNumber,
    ElOption,
    ElRadio,
    ElRadioButton,
    ElRadioGroup,
    ElRate,
    ElSelect,
    ElSwitch,
    ElTabPane,
    ElTable,
    ElTableColumn,
    ElTabs,
    ElTag,
    ElTooltip,
    ElUpload,
    ElSkeleton,
    ElSkeletonItem,
];
const plugins = [
    ElInfiniteScroll,
    ElLoading,
    ElMessage,
    ElMessageBox,
    ElNotification,
];
const install = (app, opt) => {
    const option = Object.assign(defaultInstallOpt, opt);
    locale(option.locale);
    app.config.globalProperties.$ELEMENT = option;
    setConfig(option);
    components.forEach(component => {
        app.component(component.name, component);
    });
    plugins.forEach(plugin => {
        app.use(plugin);
    });
};
var index = {
    version: version$1,
    install,
};

export default index;
export { install, locale, version$1 as version };
